import * as taskName from './task-name'
import * as processUI from '../../process-ui'
import * as processAction from '../../process-action'
import { selectProcessContext } from '../../../state/instance-detail/selector'
import { selectTreatmentPlan } from '../../../../treatment/state/plan/selector'
import { createValidationMessage } from '../../../../validation/create-validation-message'
import {
    IMPLANT_CONSULTATION_AND_FINDINGS,
    IMPLANT_TREATMENT_PHYSICIAN_ASSESSMENT,
} from '../../../../anamnesis/state/anamnesis/const'

export default {
    taskName: taskName.IMPLANT_CREATE_TREATMENT_PLAN,
    taskOverviewProps: {},
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.SALES_ORDER_CUSTOMER_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.COMMENT_LIST,
        },
        {
            component: processUI.CANNOT_BE_TREATED_REASON_WIDGET_CONTAINER,
        },
        {
            component: processUI.INITIAL_HESITATION_WIDGET_CONTAINER,
        },
        {
            component: processUI.PHYSICIAN_AND_SUPPLIER_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.ANAMNESIS_LIST_WIDGET_CONTAINER,
            widgetProps: {
                excludeTemplateKeyList: [
                    IMPLANT_TREATMENT_PHYSICIAN_ASSESSMENT,
                    IMPLANT_CONSULTATION_AND_FINDINGS
                ],
            },
        },
        {
            component: processUI.ANAMNESIS_EDIT_WIDGET_CONTAINER,
            widgetProps: {
                templateKey: IMPLANT_TREATMENT_PHYSICIAN_ASSESSMENT,
            },
        },
        {
            component: processUI.ANAMNESIS_EDIT_WIDGET_CONTAINER,
            widgetProps: {
                templateKey: IMPLANT_CONSULTATION_AND_FINDINGS,
            },
        },
        {
            component: processUI.CBCT_FILE_UPLOAD_WIDGET,
        },
        {
            component: processUI.IMPLANT_TREATMENT_PLAN_UPLOAD_WIDGET,
        },
        {
            component: processUI.CUSTOMER_IMAGE_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.SCAN_FILE_UPLOAD_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.TREATMENT_PLAN_FILE_UPLOAD_WIDGET,
        },
    ],
    actionList: [
        {
            action: processAction.PROCESS_INSTANCE,
            taskPath: ['processInstance'],
        },
        {
            action: processAction.TREATMENT_PLAN,
            taskPath: ['objectDetail', 'customer', 'treatmentPlanList', 0],
        },
        {
            action: processAction.SALES_ORDER,
            taskPath: ['objectDetail'],
        },
        {
            action: processAction.CUSTOMER,
            taskPath: ['objectDetail', 'customer'],
        },
    ],
    taskValidatorSelector: [
        selectProcessContext, selectTreatmentPlan,
    ],
    taskValidator: (task, processInstance, taskName, eventName, context) => {
        const messageList = []

        if (eventName === 'clarify_cannot_be_treated') {
            const cannotBeTreatedReason = context.cannotBeTreatedReason
            if (!cannotBeTreatedReason) {
                messageList.push(createValidationMessage("Please add the reason for 'cannot be treated' before proceeding.", 'checkDeliveryTracking.checkDeliveryTracking'))
            }
            return messageList
        }

        if (eventName === 'plan_done') {

            return messageList
        }

        return messageList
    },
}



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/implant-plan/implant-create-treatment-plan.js